import { gql } from "apollo-boost";

export const AccountFragment = gql`
  fragment AccountFragment on Account {
    id
    user {
      id
      email
    }
    organization {
      id
      orgId
      domain
    }
    domain {
      id
      domainId
    }
    status
    roles
  }
`;


